<template>
  <div class="image-profile">
    <div class="image-profile-bg" :style="bg_imagem" @click="selectFiles()" />

    <b-modal
      title="Adicionar Arquivo"
      :id="componentId"
      :ref="componentId"
      size="xl"
      ok-variant="bagsis"
      @ok="addFile"
      :footer-class="footer_class"
      @hide="hideModal"
    >
      <b-tabs v-model="tabIndex" content-class="mt-3">
        <b-tab title="Adicionar Arquivo" active>
          <TableList
            :show_actions="false"
            :show_select="true"
            :show_btn_novo="false"
            :max_select="1"
            :type="type"
            ref="files_selected"
          />
        </b-tab>
        <b-tab title="Criar Arquivo">
          <b-card>
            <Form
              @saved="arquivoCriado"
              :selectFile="true"
              :cancel_link="''"
              @cancel="voltar"
              :type="type"
            />
          </b-card>
        </b-tab>
      </b-tabs>
    </b-modal>
  </div>
</template>

<script>
import TableList from "@/modules/files/Components/TableList.vue";
import Form from "@/modules/files/Components/Form.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import _ from "lodash";
import { generateId } from "@/helpers/functions/generateId";

export default {
  components: {
    TableList,
    Form,
  },
  data: () => ({
    tabIndex: 0,
    componentId: null,
  }),
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapState("files", ["file"]),
    ...mapGetters("files", ["file_empty"]),
    local_value: {
      set(value) {
        this.$emit("input", value);
      },
      get() {
        return this.value ? this.value : this.file_empty;
      },
    },
    has_file() {
      return this.value && this.value.id;
    },
    footer_class() {
      if (this.tabIndex == 1) {
        return "d-none";
      }
      return "";
    },
    image_url() {
      return this.value ? this.value.url : null;
    },
    bg_imagem() {
      return this.image_url
        ? 'background-image: url("' + this.image_url + '")'
        : "";
    },
  },
  methods: {
    ...mapActions("files", ["ActionNewFile"]),
    addFile(evt) {
      evt.preventDefault();
      let files = this.$refs.files_selected.getSelected();
      this.local_value = files[0];

      this.$nextTick(() => {
        this.$bvModal.hide(this.componentId);
      });
    },
    selectFiles() {
      this.$bvModal.show(this.componentId);
    },
    arquivoCriado(id) {
      this.local_value = this.file;
      this.$nextTick(() => {
        this.ActionNewFile();
        this.$bvModal.hide(this.componentId);
      });
    },
    voltar() {
      this.tabIndex = 0; // 2
    },
    hideModal() {
      let query = JSON.parse(JSON.stringify(this.$route.query));
      delete query.page;
      this.$router.push({ query: query }).catch((err) => {});
    },
    removeFile() {
      this.local_value = null;
    },
  },
  async created() {
    this.ActionNewFile();
    this.componentId = "modal-arquivo-" + generateId();
  },
};
</script>

<style lang="scss">
.image-profile {
  display: flex;
  justify-content: center;
  margin-top: -50px;

  .image-profile-bg {
    width: 100px;
    height: 100px;
    background-image: url("~assets/no-user-image.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto 100px;
    border-radius: 50%;
  }

  .custom-file {
    opacity: 0;

    .custom-file-label {
      width: 100px;
      height: 100px;
      border: 1px solid red;
    }
  }
}
</style>
